export const getPresentators = (state) => state.presentators
export const getModerators = (state) => state.moderators
export const getPlannings = (state) => state.plannings
export const getCurrentPlanning = (state) => state.currentPlanning
export const getProgramEnums = (state) => state.programEnums
export const getAtelierPrograms = (state) => state.programs
export const getAtelierTypeEnum = (state) => state.atelierTypes
